import React from "react"

const ProductIcon = props => {
  return <img loading="lazy" src={props.url} />
}

export default ProductIcon
